import { parseName } from 'humanparser'
import { useMemo } from 'react'
import { useAuthContext } from '~/src/context/AuthProvider'
import useAuthUser from '~/src/hooks/useAuthUser'

const useUserData = () => {
  const { authUser } = useAuthUser()
  const { userData } = useAuthContext()

  const userName = userData?.firstName || authUser?.displayName
  const parsedName = parseName(userName || '')
  const firstName = parsedName?.firstName
  const lastName = parsedName?.lastName
  const initials =
    firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : ''

  const isD1User = useMemo(() => {
    const createdAtDate = userData?.createdAt
      ? new Date(userData?.createdAt)
      : null
    const daysSinceCreation = createdAtDate
      ? Math.floor(
          (new Date().getTime() - createdAtDate.getTime()) /
            (1000 * 60 * 60 * 24)
        )
      : 0
    const result = !!createdAtDate ? daysSinceCreation < 1 : false
    return result
  }, [userData?.createdAt])

  return {
    authUser,
    userData,
    name: userName,
    parsedName,
    initials,
    isD1User,
  }
}

export default useUserData
